import { Component, Inject, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { DialogManagerService } from '@src/services';
import { packagesActions } from '@src/store/reducers/packagesReducer';
import {projectActions} from '@src/store/reducers/projectReducer'
import { UploadScriptDialogComponent } from '@app/shared/components/dialogs';
//import { AuthorizationService } from '@src/services';
import { Store } from '@src/store';
import { consts } from '@src/constants/consts';
import moment from 'moment';
import _ from 'lodash';

@Component({
    selector: 'scriptRepository',
    template: require('./scriptRepository.html'),
    styles: [require('./scriptRepository.scss')]
})
export class ScriptRepositoryComponent implements OnDestroy {
    @Input() public isJobInProgress: boolean;
    @Input() public collapsed:boolean;
    @Input() public projectWithMetaData: any;
    @Input() public projectId: any;
    @Output() public onSelectPackageScript = new EventEmitter<any>();
    @Output() public onScriptTypeChanged = new EventEmitter<any>();
    @Output() public onClickPackage = new EventEmitter();
    @Output() public onRemoveScript = new EventEmitter();
    @Output() public onScriptTypeMoved = new EventEmitter();
    @Output() public onAddScript = new EventEmitter<any>();
    public checkedAll = false;
    public schemas = [];
    public currentItem = null;
    public scriptList: any;
    public unsubscribe2:any;
    public dataT:string;
    public tempScriptList:any;
    public scriptListTemp:any = [];
    public unsubscribe;
    public isChecked:boolean = false;
    public canEditPackageScripts:any;
    public filesBuffer = [];
    public sortItems:string[] = ['Script name', 'Date time', 'Creator', 'Schema'];
    public $translate:any;
    private _script:any;

    constructor(
        private store: Store,
        // @Inject('$q') private $q: any
        private dialogManagerService: DialogManagerService,
        @Inject('authorizationService') private authorizationService: any,
        @Inject('Upload') private Upload: any,
        @Inject('$state') public state: any,
        @Inject('$stateParams') private $stateParams: any,
        @Inject('$filter') private $filter: any) {
            this.projectId = this.$stateParams.id;
            this.dataT = this.$filter('dbTypeItem')(["Schemas"], this.state.params.dbType) 
            this.$translate = this.$filter('translate');
            this.authorizationService.isAuthorizedToPerformAction(consts.userPermissions.UpdateScript).then(canEditPackageScripts => {
                setTimeout(() => { this.canEditPackageScripts = canEditPackageScripts; }, 50);
            });
    }
    async ngOnInit(){
        await this.store.dispatch({ type: projectActions.GET_RS_SCHEMES, payload: { projectId: this.projectId } }).then(resp => {
            resp.data.forEach(schema => this.schemas.push(schema)
        )});
        this.unsubscribe = this.store.subscribe(() => {
            this.scriptList = this.store.getState().packageManager.scripts;
        });
    }
    set script(value) {
        this._script = value;
        this.onAddScript.emit({ data: value });
    }

    get script() {
        return this._script;
    }

    changeState() {
        _.each(this.scriptList, (script) => { script.checked = this.checkedAll; this.isChecked = !this.isChecked});
    }

    importScripts = () => {
        this.store.dispatch({ type: packagesActions.GET_SCRIPTS, payload: { id: this.projectId } });
    }
    showScript = (script) => {
        this.dialogManagerService.showScriptViewerDialog({
            dispatch: (action) => this.store.dispatch(action),
            projectId: this.projectId,
            scriptId: script.id,
            isPackageMode: true,
            isEnabled: script.IsEnabled,
            canEditPackageScripts: this.projectWithMetaData.canEditPackageScripts && this.canEditPackageScripts
        });
    }

    // checkScript = (script) => {
    //     showWarning(script, this.projectId, this.popUpModal, this.store, this.showScript, this.importScripts);
    // }
    public changedChecked(item){
         this.currentItem = {...item}
         this.isChecked = !this.isChecked
        //  this.currentItem.checked == true ? this.currentItem.checked = false : this.currentItem.checked = true
        //  console.log(this.currentItem)
    }

    public changeItem(){
        if(this.currentItem != null){
            _.each(this.scriptList, (script) => {
                 if(script.id == this.currentItem.id){
                        script.checked = this.isChecked
                 }
             });
        }
    }

    async onUploadFiles() {
        const _this = this;
        const fileExtensions = await _this.store.dispatch({ type: projectActions.GET_FILE_EXTENSIONS, payload: { projectId: _this.projectId } });
        const strExtensions = (fileExtensions && fileExtensions.length) ? fileExtensions.join(",") : "sql,zip,rar,tar";
        const updateScriptSource = () => {
            _this.filesBuffer = [];
            _this.store.dispatch({ type: packagesActions.GET_SCRIPTS, payload: { id: _this.projectId } });
        };
        const onConfirm = (data) => {
              if(data){
                data.files.forEach( (file) => {
                    _this.filesBuffer.push(file);
                    _this.store.dispatch({
                        type: packagesActions.UPLOAD_PACKAGE_SCRIPT,
                        payload: {
                            onResult: (response) => {
                                file.result = response.data;
                            },
                            onErrorResult: (response) => {
                                if (response.status > 0)
                                    file.errorMsg = response.status + ': ' + response.data;
                            },
                            onProgress: () => {
                                file.progress = Math.min(100);
                            },
                            projectId: _this.projectId,
                            schemaId: data.schema.id,
                            file: file,
                            uploadObject: _this.Upload
                        }
                    }).then(x => {
                        if(x){}
                        updateScriptSource()
                    });;;
                })
              }
        };
        const dialogData = { title: 'Upload Files',
        files: [],filesBuffer: _this.filesBuffer,schemas: this.schemas,schema: this.schemas.length >= 1 ? this.schemas[0] : null
        ,result: '',errorMsg: '' ,filesTypesStr:strExtensions,errors: [], progress: 0, databaseOrSchema:this.dataT,extension: fileExtensions};
        this.dialogManagerService.showDialog(dialogData, onConfirm, UploadScriptDialogComponent, 'upload-script-dialog');
    };
   async onDelete() {
        this.onRemoveScript.emit({ data: this.scriptList })
        //this.checkedAll = false;
    }

    convertUTCDateToLocalDate(date) {
        return moment.utc(date, 'DD/MM/YYYY HH:mm:ss').local().toDate().toLocaleString();//format('DD/MM/YYYY HH:mm:ss');
    }
    ngOnDestroy = function () {
        this.unsubscribe();
        this.unsubscribe2();
    };

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/packageManager/scriptRepository-ang7/scriptRepository.ts